import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideImageBlockData from '../../../Models/Content/GenericGuideImageBlockData';
import GenericGuideImage from './GenericGuideImageBlock';

export default class GenericGuideImageBlock extends EpiComponent<GenericGuideImageBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-image-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideImage iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

